var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.is_mobile)?_c('div',[_c('CourseMobile')],1):_c('div',{staticClass:"course_div"},[_c('CourseHeaderBar',{class:[_vm.scrolled ? 'show_course_header' : 'hide_course_header']}),_c('Course')],1)}
var staticRenderFns = []

export { render, staticRenderFns }